import React from 'react';

import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import type { ErrorBoundaryPropsWithRender } from 'react-error-boundary';

import { ErrorFallback } from './ErrorFallback';

type ErrorBoundaryProps = Omit<ErrorBoundaryPropsWithRender, 'fallbackRender'> & {
  title?: string;
  description?: string;
  children: React.ReactNode;
};

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ title, description, children, ...props }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={(fallbackProps) => (
        <ErrorFallback {...fallbackProps} title={title} description={description} />
      )}
      {...props}>
      {children}
    </ReactErrorBoundary>
  );
};
